import React from 'react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { UserX, Eye } from 'lucide-react';
import { useImpersonation } from '@/contexts/ImpersonationContext';

export default function ImpersonationBanner() {
  const { isImpersonating, impersonatedVendor, exitImpersonation } = useImpersonation();

  if (!isImpersonating || !impersonatedVendor) {
    return null;
  }

  return (
    <Alert 
      className="border-amber-600 bg-amber-50 dark:bg-amber-950 sticky top-0 z-50 rounded-none shadow-md"
      data-testid="impersonation-banner"
    >
      <Eye className="h-4 w-4 text-amber-600" />
      <AlertDescription className="flex items-center justify-between w-full">
        <div className="flex items-center gap-2">
          <strong className="text-amber-900 dark:text-amber-100">
            Admin Impersonation Mode:
          </strong>
          <span className="text-amber-800 dark:text-amber-200">
            You are viewing as <strong>{impersonatedVendor.name}</strong>
          </span>
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={exitImpersonation}
          className="ml-4 shrink-0 border-amber-600 text-amber-900 hover:bg-amber-100 dark:text-amber-100 dark:hover:bg-amber-900"
          data-testid="exit-impersonation-btn"
        >
          <UserX className="h-4 w-4 mr-2" />
          Exit Impersonation
        </Button>
      </AlertDescription>
    </Alert>
  );
}
